export default __webpack_public_path__ + "ee56f6ef2f1c80ed0cc1129259d6a3cd.gif";